module.exports = __webpack_public_path__ + "static/media/8import-19.344fdc88.xlsx";